import { render, staticRenderFns } from "./RefereeEdit.vue?vue&type=template&id=6192d175&"
import script from "./RefereeEdit.vue?vue&type=script&lang=js&"
export * from "./RefereeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports